export const SKILLS_PAGE_TYPE_WRITER_DELAY = 40;
